import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';

import { PCV2Request } from '@shared/interfaces/request.interface';
import { API_URIS } from '@shared/constants/api-uris.const';
import { Paperwork } from '@shared/interfaces/paperwork.interface';

const BASE_API_PCV2: string = environment.baseApiPCv2;
const URI_ONCOLOGY: string = API_URIS.oncology;

@Injectable({
  providedIn: 'root',
})
export class ClinicalOncologyService {
  constructor(private httpClient: HttpClient) {}

  save(body: Paperwork): Observable<Paperwork> {
    return this.httpClient.post<PCV2Request>(`${BASE_API_PCV2}/${URI_ONCOLOGY}`, body).pipe(
      retry(3),
      map(({ data }: { data: Paperwork }) => data),
    );
  }
}
